import ViewIcon from "@mui/icons-material/RemoveRedEye";

export default ViewIcon;
